import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';

import { ServerCommon } from '@/utils/ServerCommon';

export interface State {
  uid: string;
}

const defaultState: State = {
  uid: '',
};

const mutations: MutationTree<State> = {
  init(state: State, uid: string) {
    state.uid = uid;
    Vue.axios.defaults.headers.common['LF-Device'] = uid;
  },
};

const getters = {
};

const actions: ActionTree<State, RootState> = {
  initUid({ commit }) {
    return new Promise((resolve, reject) => {
      if (!localStorage.getItem('device-uid')) {

        ServerCommon.getUid()
          .then((uid: string) => {
            commit('init', uid);
            localStorage.setItem('device-uid', uid);
            resolve(uid);
          })
          .catch((err: any) => {
            reject(err);
          });

      }
      else {
        commit('init', localStorage.getItem('device-uid'));
        resolve();
      }

    });
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
